import React from 'react';
import classNames from 'classnames';
import * as Tabs from '@radix-ui/react-tabs';

import { noop } from 'common/utils';
import { createStyles } from '../../../utils/createStyle';
import { colors } from 'styles/settings';

import { LinkBtn } from 'components/link-btn';
import ResponsiveContainer, {
    ContainerType,
} from 'components/responsive-containers/ResponsiveContainer';

const style = createStyles({
    btn: [
        'text-center text-brand py-[10px] px-0 sm:px-[7px] md:px-[20px]',
        { borderRadius: '50px' },
        { '@media (min-width: 640px)': { padding: '8px 24px' } },
    ],
    newBtn: {
        background: colors.orange,
        height: 24,
        width: 56,
        display: 'block',
        fontSize: '14px',
        fontWeight: 600,
        color: colors.white,
        borderRadius: 50,
    },
    btnLinkContainer: 'flex items-center',
    btnLabel: [
        'text-sm sm:text-base text-brand text-center leading-4 font-semibold mr-2',
        { marginLeft: '8px' },
    ],
});

export interface ShopNavOptionProps {
    tabId: string;
    title: string;
    icon?: React.ReactNode | null;
    selected: boolean;
    onClick?: () => void;
    isNew?: boolean;
}

export const ShopNavOption = ({ onClick = noop, isNew, ...props }: ShopNavOptionProps) => {
    const { selected, icon, tabId, title } = props;
    // Stable anchor className derived from the tabId, used by coach mark
    // tours and tests to target a specific tab without depending on its
    // visible label or order. Format: `shop_nav_tab_book_travel`, etc.
    const anchorClass = `shop_nav_tab_${tabId.toLowerCase().replace(/\s+/g, '_')}`;
    return (
        <Tabs.Tab
            className={classNames(
                style.btn,
                selected && 'bg-pale-blue',
                'shrink-0',
                'scroll-mr-4',
                anchorClass
            )}
            value={tabId}
            data-state={selected ? 'active' : 'inactive'}
            aria-selected={selected}
        >
            <LinkBtn className="no-underline" onClick={onClick}>
                <div className={style.btnLinkContainer}>
                    <div>{icon}</div>
                    <div className={style.btnLabel}>{title}</div>
                    {isNew ? (
                        <ResponsiveContainer For={ContainerType.desktop}>
                            <span className={style.newBtn}>New!</span>
                        </ResponsiveContainer>
                    ) : null}
                </div>
            </LinkBtn>
        </Tabs.Tab>
    );
};
